export enum EventType {
  AllEvents = 'all',
  ClubEvent = '1',
  GroupEvent = '2',
  FunctionariesEvent = '3',
  Course = '4',
  Seminar = '5',
}

export enum Visibility {
  Public = 1,
  Private = 2,
  Group = 3,
  Club = 4,
}

export enum EventHiddenStatus {
  Hidden = 1,
  Unhidden = 0,
}
